<template>
  <div
    id="contact-person"
    class="contact-person md:tw-w-96 tw-w-11/12 tw-flex tw-flex-col tw-items-center tw-pb-8"
  >
    <OnboardingHeader headerText="Create your Account" />
    <OnboardingSubHeader
      subHeaderText="We would need your personal contact details."
    />
    <ContactPersonForm @submit-data="submitData" />
  </div>
</template>

<script>
  import { mapActions } from "vuex";
  import OnboardingHeader from "@/components/onboarding/OnboardingHeader.vue";
  import OnboardingSubHeader from "@/components/onboarding/OnboardingSubHeader.vue";
  import ContactPersonForm from "@/components/onboarding/forms/ContactPersonForm.vue";
  import { clearStorage } from "@/utils/storage.js";
  import responseHandler from "@/utils/responseHandler.js";

  export default {
    name: "ContactPerson",

    components: { OnboardingHeader, OnboardingSubHeader, ContactPersonForm },

    mounted() {
      this.showToast({
        description: "Please add contact person info.",
        display: true,
        type: "info",
      });
    },

    methods: {
      ...mapActions("organisationModule", ["updateOrgDetails"]),
      ...mapActions("loadingModule", [
        "contactPersonLoading",
        "contactPersonSuccess",
      ]),
      ...mapActions(["showToast"]),

      async submitData(data) {
        this.contactPersonLoading(true);
        const payload = {
          founders: [
            { fname: data.firstName, lname: data.lastName, email: data.email },
          ],
        };
        try {
          const response = await this.updateOrgDetails(payload);
          const { message, status } = response.data;
          if (status === "success") {
            this.contactPersonSuccess(true);
            this.showToast({
              description: message,
              display: true,
              type: "success",
            });
            this.$router.push({ name: "UploadId" });
            this.contactPersonLoading(false);
          }
        } catch (error) {
          responseHandler.handleError(error);
          clearStorage();
          this.$router.push({ name: "SignIn" });
          this.contactPersonLoading(false);
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  .contact-person {
    @media (min-width: 768px) {
      width: 440px;
    }
  }
</style>
